import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useAuth } from "../../Auth";
import api from "../../services/api";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

// import required modules
import { Grid, Keyboard, Pagination } from "swiper/modules";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import comp from "../../assets/images/icn-comp.png";
import pin from "../../assets/images/icn-pin.png";
import arrow from "../../assets/images/icn-arrow-r-w.png";

const SponsorshipOpportunitiesElement = styled.section`
  display: flex;
  justify-content: center;
  padding: 57px 20px 52px 20px;
  background: #f1f1f1;
  overflow-x: hidden;

  .cmp-events-container {
    max-width: 1280px;
    width: 100%;
  }

  .cmp-events-header {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    flex-wrap: wrap;

    @media (max-width: 815px) {
      flex-direction: column;
      align-items: flex-start;
      ul {
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        margin: 0;
      }
      ul li {
        flex: 0 0 auto;
        margin-right: 10px;
        margin-bottom:20px;
      }
    }

    h2 {
      font-size: 24px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: -0.48px;
      color: #333333;
      margin-right: 40px;

      @media (max-width: 815px) {
        margin-right: unset;
        margin-bottom: 20px;
      }
    }

    ul.cmp-events-tabs {
      display: flex;

      @media (max-width: 815px) {
        order: 3;
        margin-bottom: 10px;
      }

      li {
        &:not(:last-child) {
          margin-right: 53px;

          @media (max-width: 860px) {
            margin-right: 32px;
          }
        }

        button {
          background: none;
          border: none;
          font-size: 18px;
          font-weight: 700;
          line-height: 21px;
          letter-spacing: -0.36px;
          color: #6a6d75;
          padding: 0;

          span {
            color: #2D66AC;
          }

          &:hover {
            color: #303440;
            cursor: pointer;
          }

          &.active {
            color: #303440;
            position: relative;

            &::after {
              content: " ";
              position: absolute;
              height: 3px;
              left: 0;
              right: 0;
              bottom: -10px;
              background: #2D66AC;
            }
          }
        }
      }
    }

    a {
      margin-left: auto;
      border-radius: 30px;
      background: #2D66AC;
      border: 2px solid #2D66AC;
      text-decoration: none;
      color: #fff;
      font-size: 14px;
      font-weight: 800;
      line-height: 22px;
      letter-spacing: 0;
      padding: 4px 24px;

      @media (max-width: 815px) {
        order: 2;
        margin-left: unset;
        margin-bottom: 30px;
      }
    }
  }

  .cmp-events-feed {
    @media (max-width: 520px) {
      display: none;
    }

    .swiper {
      overflow: visible;
      padding-bottom: 50px;

      .swiper-pagination {
        bottom: 0px;

        .swiper-pagination-bullet {
          height: 15px;
          width: 15px;
          background: none;
          border: 2px solid #878990;
          opacity: 1;

          &:not(:last-of-type) {
            margin-right: 10px;
          }

          &.swiper-pagination-bullet-active {
            background: #E2680E;
            border: 2px solid #E2680E;
          }
        }
      }
    }

    .swiper-slide {
      width: 375px;
    }
  }

  .cmp-events-feed-mobile {
    @media (min-width: 521px) {
      display: none;
    }

    .cmp-events-card {
      margin-left: auto;
      margin-right: auto;
    }

    .swiper {
      padding-bottom: 50px;

      .swiper-pagination {
        bottom: 0px;

        .swiper-pagination-bullet {
          height: 15px;
          width: 15px;
          background: none;
          border: 2px solid #878990;
          opacity: 1;

          &:not(:last-of-type) {
            margin-right: 10px;
          }

          &.swiper-pagination-bullet-active {
            background: #E2680E;
            border: 2px solid #E2680E;
          }
        }
      }
    }
  }

  .cmp-events-card {
    background-size: cover;
    background-color: #303440;
    width: 375px;
    border-radius: 12px;
    height: 195px;
    position: relative;
    padding: 16px 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
     &.empty{
        
        background:unset!important;
        background-color:white!important;
        color:#000!important;
        box-shadow: 0px 3px 6px #00000029!important;
        border-radius: 7px!important;
        .cmp-event-card-title {
          color:#000!important;
          font-weight:500!important;
          font-size:20px!important;
        }
        .cmp-event-card-title p {
          color:#000!important;
          font-weight:500!important;
          font-size:16px!important;
          margin-top:5px!important;
        }
           a.cmp-event-card-button {
            border-radius: 30px!important;
            background: #fff!important;
            border: 2px solid #2D66AC!important;
            text-decoration: none!important;
            color: #2D66AC!important;
            font-size: 14px!important;
            line-height: 22px!important;
            letter-spacing: 0!important;
            padding: 6px 26px!important;
            font-weight: 700!important;
            margin-left:0!important;
            margin-right:auto!important;
            width:200px!important;
        
      }
      .cmp-learning-card-link:hover {
        background-color: #2D66ACimportant; /* Change the background color on hover */
        color: #fff!important; /* Change the text color on hover */
        cursor: pointer;
        
      }
      }
    
    &:not(.empty)::before {
      border-radius: 12px;
      content: " ";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: rgb(36, 39, 49);
      background: linear-gradient(
        90deg,
        rgba(36, 39, 49, 0.9) 0%,
        rgb(130 130 133 / 40%) 100%
      );
      opacity: 0.9;
      z-index: 1;
    }

    .cmp-events-card-header,
    .cmp-events-card-footer {
      z-index: 2;
      position: relative;
    }

    .cmp-events-card-header {
      .cmp-event-card-date,
      .cmp-event-card-location {
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 0;
        color: #fff;
      }

      .cmp-event-card-title {
        font-size: 20px;
        line-height: 22px;
        letter-spacing: 0;
        font-weight: 700;
        color: #fff;
        margin: 3px 0;
      }
      a.cmp-event-card-button {
        font: Roboto;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        padding: 8px;
        border-radius: 6px;
        background-color: #E2680E;
        margin-bottom: 14px;
        width:90px;
        text-transform: uppercase;
        text-align:center!important;
        display:block!important;
        &:hover {
          background: transparent;
          color: #fff;
        }

        &.register {
          background: #E2680E;
          color: #fff;
          display: flex;
          align-items: center;
          border: 2px solid #E2680E;

          img {
            width: 16px;
            height: 18px;
            margin-right: 6px;
          }
        }
      }
    }

    .cmp-events-card-footer {
      display: flex;
      align-items: center;
     
      .cmp-event-card-type-icon {
        margin-right: 20px;

        img {
          height: 22px;
          width: auto;
        }
      }

      a.cmp-event-card-button {
        background: #ffffff;
        border: 2px solid #fff;
        font-size: 16px;
        line-height: 22px;
        font-weight: 700;
        text-decoration: none;
        color: #303440;
        border-radius: 30px;
        padding: 3px 21px;

        &:hover {
          background: transparent;
          color: #fff;
        }

        &.register {
          background: #E2680E;
          color: #fff;
          display: flex;
          align-items: center;
          border: 2px solid #E2680E;

          img {
            width: 16px;
            height: 18px;
            margin-right: 6px;
          }
        }
      }

      a.cmp-event-card-more-info {
        margin-left: auto;
        display: flex;
        align-items: center;
        text-transform: uppercase;
        text-decoration: none;
        color: #fff;
        font-size: 14px;
        line-height: 16px;
        font-weight: 900;

        img {
          height: 16px;
          width: 16px;
          margin-left: 10px;
        }
      }
    }
  }

  .cmp-event-feed-empty {
    padding: 40px 0 20px 0;
  }

  .cmp-debug-btn {
    border-radius: 30px;
    background: #E2680E;
    border: 2px solid #E2680E;
    -webkit-text-decoration: none;
    text-decoration: none;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    -webkit-letter-spacing: 0;
    -moz-letter-spacing: 0;
    -ms-letter-spacing: 0;
    letter-spacing: 0;
    padding: 4px 24px;
    margin-top: 10px;
  }

  .loading-container {
    display: flex;

    .loading-card {
      height: 240px;
      width: 100%;
      background: #fff;
      border-radius: 7px;
      padding: 26px 24px 21px;
      display: flex;
      flex-direction: column;

      &:not(:last-child) {
        margin-right: 20px;
      }

      .loading-card-footer {
        margin-top: auto;
        display: flex;

        div {
          &:nth-child(1) {
            width: 12%;
            margin-right: 26px;
          }

          &:nth-child(2) {
            width: 35%;
          }
        }
      }
    }
  }
`;

const SponsorshipOpportunities = () => {

  const [activeTab, setActiveTab] = useState("all");
  const [loading, setLoading] = useState(true);
  const [eventData, setEventData] = useState(null);
  const [events, setEvents] = useState(null);

  const { cmpData, environment, cuesURL, canSectionLoad, markSectionLoaded } = useAuth();

  function handleGAEvent(eventTitle, value) {
    if (cmpData) {
      // if (window.location.host === "mycues.cues.org") {
        // Push event to GTM data layer
        if (window.dataLayer) {
          window.dataLayer.push({
            event: eventTitle,
            event_category: 'Sponsorship',
            event_label: value,
            value: value,
            user_role: cmpData.account_info.acgiRole,
            user_memberlevel: cmpData.account_info.membershipLevel,
            user_company: cmpData.account_info.employer,
          });
        }
      // }
    }
  }

  useEffect(() => {
    if (cmpData && canSectionLoad('cmp_sponsorship_opportunities') && !eventData) {
      const sponsorshipApiUrl = cuesURL + "/cmp/sponsorship-opportunities";

      api.get(sponsorshipApiUrl)
        .then(function (response) {
          setEventData(response.data.data);
          setLoading(false);
          markSectionLoaded('cmp_sponsorship_opportunities');
        })
        .catch(function (error) {
          setLoading(false);
          markSectionLoaded('cmp_sponsorship_opportunities'); // Mark as loaded even on error
        });
    }
  }, [cmpData, canSectionLoad, cuesURL, eventData, markSectionLoaded]);

  useEffect(() => {
    if (!loading && eventData) {
      switch (activeTab) {
        case "all":
          setEvents(eventData);
          break;
        case "ceo":
          setEvents(eventData.filter(event => event.roles?.includes("CEO") || event.roles?.includes("Executive")));
          break;
        case "manager":
          setEvents(eventData.filter(event => event.roles?.includes("Manager") || event.roles?.includes("Staff")));
          break;
        case "board":
          setEvents(eventData.filter(event => event.roles?.includes("Board")));
          break;
        default:
          break;
      }
    }
  }, [loading, activeTab, eventData]);

  return (
    <>
      {loading && (
        <SponsorshipOpportunitiesElement>
          <div id="sponsorshipOpportunities" className="cmp-events-container">
            {/* Header */}
            <div className="cmp-events-header">
              <h2>Event Sponsorship Opportunities</h2>
            </div>

            <div className="loading-container">
              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={2} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>

              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={2} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>

              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={2} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SponsorshipOpportunitiesElement>
      )}

      {!loading && eventData && events && (
        <SponsorshipOpportunitiesElement>
          <div id="sponsorshipOpportunities" className="cmp-events-container">
            {/* Header */}
            <div className="cmp-events-header">
              <h2>Event Sponsorship Opportunities</h2>
              <ul className="cmp-events-tabs">
                <li>
                  <button
                    className={activeTab === "all" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("all");
                    }}
                  >
                    All
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "ceo" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("ceo");
                    }}
                  >
                    CEO/Executive
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "manager" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("manager");
                    }}
                  >
                    {/* Display the number of events the user has registered for. */}
                    Manager/Staff

                  </button>
                </li>
                <li>
                  <button
                    className={activeTab === "board" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("board");
                    }}
                  >
                    {/* Display the number of events the user has registered for. */}
                    Board

                  </button>
                </li>
              </ul>

              <a
                href={
                  "https://www.cues.org/sponsorshipopportunities"
                }
                target="_blank"
                rel="noreferrer"
                className="cmp-events-view-all-link"
                onClick={() => {
                  handleGAEvent("events_viewall");
                }}
              >
                VIEW ALL EVENTS
              </a>
            </div>

            {/* Feed */}
            <div className="cmp-events-feed">
              {eventData && events && Object.values(events).length > 0 ? (
                <Swiper
                  simulateTouch={true}
                  slidesPerView={"auto"}
                  slidesPerGroup={3}
                  spaceBetween={30}
                  keyboard={{
                    enabled: true,
                  }}
                  pagination={{
                    type: 'none'
                  }}
                  modules={[Pagination, Keyboard]}
                  className="mySwiper"
                >
                  <>
                    {Object.values(events).map((event, index) => (
                      <SwiperSlide key={event.eventId || event.title || `event-${index}`}>
                        <div
                          className="cmp-events-card"
                          data-event-id={event.eventId}
                          data-event-node-id={event.eventNodeId}
                          style={{
                            backgroundImage: event.image
                              ? `url("${event.image}")`
                              : `none`,
                          }}
                        >

                          <div className="cmp-events-card-header">
                            {event.url ? (
                              <a
                                href={
                                  activeTab === "registered"
                                    ? cuesURL + event.url
                                    : event.url
                                }
                                target="_blank"
                                rel="noreferrer"
                                className="cmp-event-card-header-link"
                                onClick={() => {
                                  if (activeTab === "registered") {
                                    handleGAEvent(
                                      "events_currently_registered",
                                      event.url
                                    );
                                  } else {
                                    handleGAEvent("events_moreinfo", event.url);
                                  }
                                }}
                              >
                                <p className="cmp-event-card-date">{event.date}</p>
                                <p className="cmp-event-card-title">
                                  {event.title}
                                </p>
                              </a>
                            ) : (
                              <>
                                <p className="cmp-event-card-date">{event.date}</p>
                                <p className="cmp-event-card-title">
                                  {event.title}
                                </p>
                              </>
                            )}

                            {/* {event.eventLocation && (
                              <p className="cmp-event-card-location">
                                {event.eventLocation}
                              </p>
                            )} */}
                          </div>

                          <div className="cmp-events-card-footer">
                            <div className="cmp-event-card-type-icon">
                              {event.eventLocation !== "In-Person Event" ? (
                                <img src={pin} alt="Online Event" />
                              ) : (
                                <img src={comp} alt="In-Person Event" />
                              )}
                            </div>

                            {event.url && (
                              <>
                                <a
                                  href={
                                    activeTab === "registered"
                                      ? cuesURL + event.url
                                      : event.url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                  className="cmp-event-card-more-info"
                                  onClick={() => {
                                    if (activeTab === "registered") {
                                      handleGAEvent(
                                        "events_currently_registered",
                                        event.url
                                      );
                                    } else {
                                      handleGAEvent(
                                        "events_moreinfo",
                                        event.url
                                      );
                                    }
                                  }}
                                >
                                  More Info <img src={arrow} alt="" />
                                </a>
                              </>
                            )}
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </>
                </Swiper>
              ) : (
                <div className="cmp-event-feed-empty">


                  <div className="cmp-events-card empty">
                    <div className="cmp-events-card-header">
                      <div className="cmp-event-card-title">
                        No Opportunities—For Now!
                        <p>We don't have sponsorships for this audience right now. Explore all opportunities or expand your search to connect with more credit union leaders.</p>
                        <a
                          className="cmp-event-card-button"
                          href="https://www.cues.org/sponsorshipopportunities"
                          target="_blank"
                          rel="noreferrer"
                        >VIEW ALL EVENTS</a>
                      </div>
                    </div>
                    <div className="cmp-events-card-footer">
                    </div>

                  </div>
                </div>
              )}
            </div>

            {/* Mobile Feed */}
            <div className="cmp-events-feed-mobile">
              {eventData && events && Object.values(events).length > 0 ? (
                <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  pagination={{
                    clickable: true,
                  }}
                  modules={[Grid, Pagination]}
                  className="mySwiper"
                >
                  <>
                    {Object.values(events).map((event, index) => (
                      <SwiperSlide key={event.eventId || event.title || `event-mobile-${index}`}>
                        <div
                          className="cmp-events-card"
                          data-event-id={event.eventId}
                          data-event-node-id={event.eventNodeId}
                          style={{
                            backgroundImage: event.image
                              ? `url("${event.image}")`
                              : `none`,
                          }}
                        >
                          <div className="cmp-events-card-header">
                            {event.url ? (
                              <a
                                href={event.url}
                                target="_blank"
                                rel="noreferrer"
                                className="cmp-event-card-header-link"
                                onClick={() => {
                                  if (activeTab === "registered") {
                                    handleGAEvent(
                                      "events_currently_registered",
                                      event.url
                                    );
                                  } else {
                                    handleGAEvent("events_moreinfo", event.url);
                                  }
                                }}
                              >
                                <p className="cmp-event-card-date">{event.date}</p>
                                <p className="cmp-event-card-title">
                                  {event.title}
                                </p>
                              </a>
                            ) : (
                              <>
                                <p className="cmp-event-card-date">{event.date}</p>
                                <p className="cmp-event-card-title">
                                  {event.title}
                                </p>
                              </>
                            )}
                          </div>

                          <div className="cmp-events-card-footer">
                          <div className="cmp-event-card-type-icon">
                              {event.eventLocation !== "In-Person Event" ? (
                                <img src={pin} alt="Online Event" />
                              ) : (
                                <img src={comp} alt="In-Person Event" />
                              )}
                            </div>
                            {/* Show registered button for registered events, or show register button for non-registered events */}

                            {event.url && (
                              <a
                                href={event.url}
                                target="_blank"
                                rel="noreferrer"
                                className="cmp-event-card-more-info"
                                onClick={() => {
                                  if (activeTab === "registered") {
                                    handleGAEvent(
                                      "events_currently_registered",
                                      event.url
                                    );
                                  } else {
                                    handleGAEvent(
                                      "events_moreinfo",
                                      event.url
                                    );
                                  }
                                }}
                              >
                                More Info <img src={arrow} alt="" />
                              </a>
                            )}
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </>
                </Swiper>
              ) : (
                <div className="cmp-event-feed-empty">


                  <div className="cmp-events-card empty">
                    <div className="cmp-events-card-header">
                      <div className="cmp-event-card-title">
                        No Opportunities—For Now!
                        <p>We don't have sponsorships for this audience right now. Explore all opportunities or expand your search to connect with more credit union leaders.</p>
                        <a
                          className="cmp-event-card-button"
                          href="https://www.cues.org/sponsorshipopportunities"
                          target="_blank"
                          rel="noreferrer"
                        >VIEW ALL EVENTS</a>
                      </div>
                    </div>
                    <div className="cmp-events-card-footer">
                    </div>

                  </div>
                </div>
              )}
            </div>
          </div>
        </SponsorshipOpportunitiesElement>
      )}
    </>
  );
};

export default SponsorshipOpportunities;
